import { Field, FieldProps } from 'formik';
import React from 'react';
import { injectIntl, InjectedIntl } from 'react-intl';
import { PayVaultAPIService } from '../../../../../api/payVault/payVaultAPI';
import ErrorMessage from '../../../../../app/common/components/errorMessage/ErrorMessage';
import { TranslationHelpers } from '../../../../../i18n/translationHelpers';
import styled from 'styled-components';
import PaymentOutterInput from './PaymentOutterInput';

interface IPayVaultCardNumberFieldProps {
    intl: InjectedIntl;
}

interface IPayVaultCardNumberFieldState {
    fieldValidationError: boolean;
    brandName?: string;
    focus: boolean;
}

const CardNumberWrapper = styled.div`
    position: relative;
`;

const ErrorMessageWrapper = styled.div`
    margin-left: 0.625rem;
`;

class PayVaultCardNumberField extends React.Component<
    IPayVaultCardNumberFieldProps,
    IPayVaultCardNumberFieldState
> {
    private readonly ID: string;

    constructor(props: IPayVaultCardNumberFieldProps) {
        super(props);
        this.ID = 'payvault-card-number-field';
        this.validate = this.validate.bind(this);
        this.renderInputField = this.renderInputField.bind(this);
        this.state = {
            fieldValidationError: false,
            focus: false,
        };
    }

    public render() {
        return (
            <div>
                <Field name={this.ID} validate={this.validate} render={this.renderInputField} />
            </div>
        );
    }

    public renderInputField({ form: { setTouched, touched } }: FieldProps) {
        PayVaultAPIService.cardNumberFocusEventListener(() => {
            this.setState({
                focus: true,
            });
        });

        PayVaultAPIService.cardNumberBlurEventListener(() => {
            this.setState({
                focus: false,
            });
            touched['cardNumber'] = true;
            setTouched(touched);
        });

        const { fieldValidationError, focus } = this.state;
        const labelClassName =
            (touched['cardNumber'] && fieldValidationError) || this.state.focus
                ? 'form-label-focus'
                : 'form-label';

        return (
            <>
                <CardNumberWrapper>
                    <label
                        className={labelClassName}
                        id="card_number"
                        htmlFor="card-number-element"
                    >
                        {TranslationHelpers.getFormattedMessage('label.card_number')} *
                    </label>
                    <PaymentOutterInput
                        data-qa-id="pv-card-number-field"
                        id="my-card-mount"
                        showError={touched['cardNumber'] && fieldValidationError}
                        field={'card'}
                        focus={focus}
                        aria-labelledby="card_number"
                    ></PaymentOutterInput>
                </CardNumberWrapper>
                {touched['cardNumber'] && fieldValidationError && (
                    <ErrorMessageWrapper>
                        <ErrorMessage
                            message={TranslationHelpers.getMessageDescriptor(
                                'error.card_number_invalid',
                            )}
                            dataQaId="payvault-card-number-error-field"
                        />
                    </ErrorMessageWrapper>
                )}
            </>
        );
    }

    private async validate(): Promise<string> {
        const isValid: boolean | undefined = await PayVaultAPIService.validateCardNumber();
        if (isValid !== undefined && !isValid) {
            this.setState({ fieldValidationError: true });
            return 'card number invalid';
        } else {
            this.setState({ fieldValidationError: false });
            return '';
        }
    }
}
export default injectIntl(PayVaultCardNumberField);
